import axiosClient from "./axiosClient";

const quiet = { __silentGenericToast: true };
const paths = { accept: "accept", start: "start", ready: "ready", complete: "complete", cancel: "cancel", reject: "reject", no_show: "no-show" };
const unwrap = response => response?.data?.data ?? response?.data?.payload ?? response?.data;
export const bookingWorkspacePath = id => `/app/scheduling/bookings/${encodeURIComponent(id)}`;
export const newBookingOperationKey = () => `booking:${crypto.randomUUID()}`;

// The capability and both versions belong to the same authoritative read snapshot.
export function bookingCommand(workspace, code, reason, operationKey) {
  const action = workspace?.actions?.find(item => item.code === code);
  if (!paths[code] || !action?.permitted) throw new Error("This action is unavailable. Refresh the booking.");
  if (!["none", "linked"].includes(workspace.orderLinkState)) throw new Error("Resolve the booking's financial link before changing it.");
  const id = workspace.navigation?.bookingId;
  const version = workspace.booking?.version;
  if (!id || !Number.isSafeInteger(version) || version < 1) throw new Error("Reload the booking to obtain its current version.");
  const linked = workspace.orderLinkState === "linked";
  const normalizedReason = String(reason || "").trim();
  if (action.requiresReason && !normalizedReason) throw new Error("A reason is required.");
  if (normalizedReason.length > (linked ? 200 : 500)) throw new Error("The reason is too long.");
  const body = { expectedVersion: version };
  if (code === "cancel" || code === "reject") body.reason = normalizedReason || null;
  if (linked) {
    if (!workspace.order?.id || !Number.isSafeInteger(workspace.order.version) || workspace.order.version < 1 || !operationKey)
      throw new Error("Reload the linked order before changing this booking.");
    body.expectedOrderVersion = workspace.order.version;
    body.operationKey = operationKey;
  }
  return { url: `/scheduling/bookings/${encodeURIComponent(id)}/${paths[code]}`, body };
}

export const bookingWorkspaceApi = {
  async get(id) { return unwrap(await axiosClient.get(`/scheduling/workspace/bookings/${encodeURIComponent(id)}`, quiet)); },
  async list(params) { return unwrap(await axiosClient.get("/scheduling/workspace/bookings", { params, ...quiet })); },
  async execute(command) {
    const response = await axiosClient.post(command.url, command.body, quiet);
    if (response?.data?.success === false) throw new Error(response.data.message || "Booking could not be updated.");
    return { data: unwrap(response), replay: response?.data?.replay === true };
  },
};
